export default __webpack_public_path__ + "static/media/ban-desktop-image-4.8128c091.jpg";